import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db5c4a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]

import { PropType, WritableComputedRef, computed, useAttrs } from 'vue';
import { FieldSelectOption } from '@/interfaces/field-select-option';


export default /*#__PURE__*/_defineComponent({
  __name: 'FieldSelect',
  props: {
  modelValue: {
    type: String,
  },
  options: {
    type: Array as PropType<FieldSelectOption[]>,
    required: true,
  },
},
  emits: {
  'update:modelValue': null,
},
  setup(__props, { emit }) {

const props = __props;





const attrs = useAttrs();

const fieldValue: WritableComputedRef<string | undefined> = computed({
  get(): string | undefined {
    return props.modelValue;
  },
  set(value: string | undefined): void {
    emit('update:modelValue', value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("select", _mergeProps({
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldValue) ? (fieldValue).value = $event : null))
    }, _unref(attrs)), [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_1))
      }), 128))
    ], 16), [
      [_vModelSelect, _unref(fieldValue)]
    ])
  ]))
}
}

})